import React, { useState, useEffect } from 'react';
import API from '../../utils/api';

const DEPARTMENTS = [
    { key: 'OPD', label: 'OPD', color: '#3b82f6', bg: '#eff6ff', icon: '🏥' },
    { key: 'LAB', label: 'Laboratory', color: '#8b5cf6', bg: '#f5f3ff', icon: '🔬' },
    { key: 'RAD', label: 'Radiology', color: '#0891b2', bg: '#ecfeff', icon: '🩻' },
    { key: 'PSY', label: 'Psychiatry', color: '#059669', bg: '#f0fdf4', icon: '🧠' },
];

export default function QueueDisplay() {
    const [queues, setQueues] = useState({});
    const [fullscreen, setFullscreen] = useState(null);

    const load = async () => {
        try {
            const res = await API.get('/queue/all');
            setQueues(res.data);
        } catch {}
    };

    useEffect(() => {
        load();
        const interval = setInterval(load, 10000);
        return () => clearInterval(interval);
    }, []);

    if (fullscreen) {
        const dept = DEPARTMENTS.find(d => d.key === fullscreen);
        const q = queues[fullscreen] || { current_token: null, waiting: 0, done: 0 };
        return (
            <div onClick={() => setFullscreen(null)} style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: dept.bg, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', zIndex: 9999 }}>
                <div style={{ fontSize: 28, color: dept.color, fontWeight: 700, marginBottom: 16 }}>{dept.icon} {dept.label} — Token Display</div>
                <div style={{ fontSize: 14, color: '#64748b', marginBottom: 40 }}>Click anywhere to exit fullscreen</div>
                <div style={{ fontSize: 28, color: '#64748b', fontWeight: 600, marginBottom: 20 }}>NOW SERVING</div>
                <div style={{ fontSize: 140, fontWeight: 900, color: dept.color, lineHeight: 1, letterSpacing: 4 }}>
                    {q.current_token || '---'}
                </div>
                <div style={{ display: 'flex', gap: 60, marginTop: 60 }}>
                    <div style={{ textAlign: 'center' }}>
                        <div style={{ fontSize: 60, fontWeight: 800, color: '#f59e0b' }}>{q.waiting}</div>
                        <div style={{ fontSize: 18, color: '#64748b' }}>Waiting</div>
                    </div>
                    <div style={{ textAlign: 'center' }}>
                        <div style={{ fontSize: 60, fontWeight: 800, color: '#22c55e' }}>{q.done}</div>
                        <div style={{ fontSize: 18, color: '#64748b' }}>Done Today</div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 24 }}>
                <div>
                    <h2 style={{ fontSize: 20, fontWeight: 800, color: '#1e3a5f', margin: 0 }}>🎫 Queue Display Board</h2>
                    <p style={{ fontSize: 12, color: '#64748b', margin: '2px 0 0' }}>Live token status — auto refreshes every 10 seconds</p>
                </div>
                <button onClick={load} style={{ padding: '8px 18px', background: '#1e3a5f', color: 'white', border: 'none', borderRadius: 8, fontSize: 12, fontWeight: 600, cursor: 'pointer' }}>
                    🔄 Refresh
                </button>
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 20 }}>
                {DEPARTMENTS.map(dept => {
                    const q = queues[dept.key] || { current_token: null, waiting: 0, done: 0 };
                    return (
                        <div key={dept.key} style={{ background: 'white', borderRadius: 14, border: `2px solid ${dept.color}20`, overflow: 'hidden', boxShadow: '0 2px 12px rgba(0,0,0,0.06)' }}>
                            <div style={{ background: dept.color, padding: '14px 20px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                <div style={{ color: 'white', fontWeight: 700, fontSize: 16 }}>{dept.icon} {dept.label}</div>
                                <button onClick={() => setFullscreen(dept.key)} style={{ background: 'rgba(255,255,255,0.2)', color: 'white', border: 'none', borderRadius: 6, padding: '4px 10px', fontSize: 11, cursor: 'pointer', fontWeight: 600 }}>
                                    ⛶ Fullscreen
                                </button>
                            </div>
                            <div style={{ padding: 24, textAlign: 'center' }}>
                                <div style={{ fontSize: 12, color: '#64748b', fontWeight: 600, letterSpacing: 1, marginBottom: 8 }}>NOW SERVING</div>
                                <div style={{ fontSize: 64, fontWeight: 900, color: dept.color, letterSpacing: 2, lineHeight: 1 }}>
                                    {q.current_token || '---'}
                                </div>
                                <div style={{ display: 'flex', justifyContent: 'center', gap: 32, marginTop: 20 }}>
                                    <div>
                                        <div style={{ fontSize: 28, fontWeight: 800, color: '#f59e0b' }}>{q.waiting}</div>
                                        <div style={{ fontSize: 11, color: '#64748b' }}>Waiting</div>
                                    </div>
                                    <div>
                                        <div style={{ fontSize: 28, fontWeight: 800, color: '#22c55e' }}>{q.done}</div>
                                        <div style={{ fontSize: 11, color: '#64748b' }}>Done Today</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}
